// products
const LOAD_PRODUCTS = '🗄  Load products'
const LOAD_PRODUCTS_TMP = 'Load product tmp'
const FETCH_PRODUCTS_PENDING = '🕐 Fetch product pending'
const FETCH_PRODUCTS_SUCCESS = '✅ Fetch product success'
const FETCH_PRODUCTS_FAILURE = '❌ Fetch product failed'
const SET_DELETED_PRODUCT = '✅ Set deleted product'

const UPDATE_PARAMS = '✨ product_update_params'

// events
const SET_DATELIST = '🕐 Set date list'
const SET_SELECTED_DATE = '🕐 Set current date'

export default {
  LOAD_PRODUCTS,
  LOAD_PRODUCTS_TMP,
  FETCH_PRODUCTS_FAILURE,
  FETCH_PRODUCTS_PENDING,
  FETCH_PRODUCTS_SUCCESS,
  UPDATE_PARAMS,
  SET_DATELIST,
  SET_SELECTED_DATE,
  SET_DELETED_PRODUCT,
}
